import { EnquiryShowBidEnquiry } from "../../enquiries/components"

const BidShowBidEnquiry = (props) => {
  return (
    <EnquiryShowBidEnquiry {...props} {...{ id: props?.record?.enquiryId }} />
  )
}

export { BidShowBidEnquiry }
